import { Box } from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";

export const HandledInvoicesBubble = () => (
    <Box
        sx={{
            backgroundColor: "rgb(221, 227, 240)",
            height: "180px",
            width: "180px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "100%",
        }}
    >
        <Box>
            <Typography
                variant="leadSmall"
                color="#2d456e"
            >
                400
            </Typography>
            <Typography
                variant="titleMedium"
                color="#2d456e"
            >
                mln
            </Typography>
        </Box>
        <Box>
            <Typography
                variant="subtitle"
                color="#5a6872"
            >
                fatture gestite
            </Typography>
        </Box>
    </Box>
);
